<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="queryParam.neighborId" placeholder="请选择小区"
						    option-filter-prop="children"  :filter-option="filterOption" show-search allowClear>
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label>设备地址</label>
			<a-input style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="queryParam.collectAddr"/>
			<a-button size="small"   icon="search" @click="doQuery">查询</a-button>
			<a-button size="small"   icon="plus" type="primary" @click="showAddView()" style="margin-left: 0.625rem;">新增</a-button>
			<a-button :loading="exportLoading" size="small"   icon="download"  :disabled="dataList.length==0"
			type="primary" @click="exportData()" style="margin-left: 0.625rem;">导出</a-button>
		</div>
		<vxe-table  align="center" :data="dataList"  border max-height="600"   ref="mTable"
						  resizable highlight-hover-row :loading="loading" size="mini">
			<vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
			<vxe-table-column title="小区" field="neighborId"   :formatter="getNeighborName"></vxe-table-column>
			<vxe-table-column title="设备地址" field="deviceAddress"  width="140"></vxe-table-column>
			<vxe-table-column title="IMEI" field="imei"  width="140"></vxe-table-column>
			<vxe-table-column title="IMSI" field="imsi"  width="140"></vxe-table-column>
			<vxe-table-column title="ICCID" field="iccid" width="140"></vxe-table-column>
			<vxe-table-column title="安装地址" field="installAddress" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="创建时间" field="createTime"  width="160"></vxe-table-column>
			<vxe-table-column title="操作" field="id" width="200">
				<template #default="{ row }">
					<a-button size="small"  type="link" @click="showUpdateView(row)">修改</a-button>
					<a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(row)">
						<a-button size="small"  type="link">删除</a-button>
					</a-popconfirm>
					<a-button size="small"  type="link" @click="showConfigView(row)">配置</a-button>
					<a-button size="small"  type="link" @click="showInfoView(row)">查看</a-button>
				</template>
			</vxe-table-column>
		</vxe-table>
		<AddNewDy4GCollect :neighborList="neighborList" ref="addView" @successHandler="doQuery"/>
		<EditDy4GCollect :neighborList="neighborList" ref="editView" @successHandler="doQuery"/>
		<Dy4GCollectMeterConfigView ref="configView"/>
		<Dy4GDeviceInfo ref="infoView"/>
	</div>
</template>

<script>
	import AddNewDy4GCollect from '../components/AddNewDy4GCollect.vue'
	import EditDy4GCollect from '../components/EditDy4GCollect.vue'
	import Dy4GCollectMeterConfigView from '../components/Dy4GCollectMeterConfigView.vue'
	import Dy4GDeviceInfo from '../components/Dy4GDeviceInfo.vue'
	export default {
		components: {
			AddNewDy4GCollect,
			EditDy4GCollect,
			Dy4GCollectMeterConfigView,
			Dy4GDeviceInfo,
		},
		data() {
			return {
				queryParam: {
					neighborId:null,
					collectAddr:null,
				},
				neighborList:[],
				dataList:[],
				loading:false,
				exportLoading:false,
			}
		},
		methods: {
			exportData(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.DY_4G_EXPORT_DATA_URL);
				this.Api.fetchPostFile(url,this.queryParam).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '4G采集器.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			showInfoView(row){
				this.$refs.infoView.showView(row);
			},
			showConfigView(row){
				this.$refs.configView.showView(row);
			},
			showUpdateView(row){
				this.$refs.editView.showView(row);
			},
			deleteContent(row){
				let param = {
					theId:row.id
				};
				let url = this.Api.getLastUrl(this.Api.DELETE_DY_4G_COLLECT_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('删除成功');
						this.doQuery();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
			showAddView(){
				this.$refs.addView.showView();
			},
			doQuery(){
				let url = this.Api.getLastUrl(this.Api.DY_4G_COLLEC_DEVICE_LIST_URL);
				this.Api.fetchPostWithForm(url,this.queryParam).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
			getNeighborName({cellValue}){
				let result = null;
				for(var i=0;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(item.pId == cellValue){
						result =  item.neighborName;
						break;
					}
				}
				return result;
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			queryNeighbors:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
						this.doQuery();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created() {
			this.queryNeighbors();
		}
	}
</script>

<style>
</style>
